module.exports = __webpack_public_path__ + "static/media/foodtransport1.6785f142.jpg";